<template>
    <nav
        role="navigation"
        :aria-label="$t('a11y-labels.header.nav')"
        class="pro-nav"
        :class="{ 'pro-nav--mobile-active': mobileMenuActive }"
        v-trap="mobileMenuActive"
    >
        <div class="pro-nav__container">
            <div class="pro-nav__main container">
                <ProLink :to="{ path: '/' }" class="pro-nav__brand" :title="`Procreate – ${$t('global.home')}`">
                    <svg viewBox="0 0 218 36" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path
                            d="M60.326 9.108c-8.066 0-13.226 5.46-13.226 13.325 0 7.967 5.16 13.427 13.226 13.427 8.116 0 13.276-5.46 13.276-13.427 0-7.865-5.16-13.325-13.276-13.325zm150.499 18.086c-1.403 5.359-5.611 8.567-11.272 8.567-7.515 0-12.074-5.512-12.074-12.926 0-7.716 4.91-13.226 12.174-13.226 7.264 0 11.373 5.561 11.373 13.076v.851h-19.238v.2c.3 5.06 3.306 8.517 7.665 8.517 2.805 0 5.61-1.453 6.813-5.059h4.559zm-69.173 0c-1.403 5.359-5.611 8.567-11.272 8.567-7.515 0-12.074-5.512-12.074-12.926 0-7.716 4.91-13.226 12.174-13.226 7.265 0 11.372 5.561 11.372 13.076v.851h-19.237v.2c.3 5.06 3.307 8.517 7.665 8.517 2.806 0 5.61-1.453 6.813-5.059h4.559zm-41.447-1.253c-.651 5.66-4.76 9.82-11.523 9.82-7.516 0-12.174-5.562-12.174-13.076 0-7.515 4.658-13.076 12.174-13.076 6.462 0 10.52 3.907 11.372 9.218h-4.208c-.702-3.256-2.956-5.711-7.164-5.711-5.16 0-8.167 4.057-8.167 9.569 0 5.51 3.007 9.568 8.167 9.568 4.459 0 6.813-2.705 7.414-6.312h4.109zm77.189-23.797v8.016h9.17v3.506h-9.17v13.276c0 3.257 1.753 5.011 5.06 5.011.983 0 2.123-.132 3.343-.549v3.646c-.996.33-2.122.51-3.343.51-5.611 0-9.168-3.307-9.168-8.618V13.666h-5.261V10.16h.05c3.958 0 5.211-1.102 5.211-4.61V2.144h4.108zm-15.342 17.835v-1.102c0-3.558-2.255-5.761-5.912-5.761-3.457 0-5.761 1.904-5.961 4.959h-4.109c.15-5.211 4.008-8.466 10.07-8.466 6.112 0 9.92 3.557 9.92 9.268v16.332h-4.008v-3.958h-.1c-1.203 1.904-4.259 4.208-8.818 4.208-4.909 0-8.166-2.755-8.166-7.163 0-4.76 3.557-8.317 13.627-8.317h3.457zM37.064 9.76v6.412c1.448-4.211 4.479-6.15 8.98-6.567v7.096c-6.621-.179-8.98 2.765-8.98 8.939v9.569H30V9.76h7.064zm71.129.4v6.107c1.747-3.968 5.099-5.804 9.48-6.21v4.464c-6.324-.053-9.48 3.044-9.48 9.917v10.771h-4.108V10.16h4.108zM15.298.14c7.414 0 12.224 4.61 12.224 10.922 0 6.311-4.81 11.072-12.224 11.072H7.866v13.075H0V.14h15.298zm146.754 25.4c0 3.456-3.608 6.613-8.016 6.613-3.106 0-5.06-1.453-5.06-3.958 0-2.805 2.205-5.01 9.619-5.01h3.457v2.355zM60.326 30.199c-4.008 0-6.313-3.257-6.313-7.766 0-4.408 2.305-7.664 6.313-7.664 4.058 0 6.363 3.256 6.363 7.664 0 4.509-2.305 7.766-6.363 7.766zm146.541-9.769c-.1-4.208-2.705-7.314-7.264-7.314-4.308 0-6.964 2.805-7.715 7.314h14.979zm-69.172 0c-.1-4.208-2.706-7.314-7.264-7.314-4.309 0-6.964 2.805-7.715 7.314h14.979zm-123.6-4.208c3.607 0 5.712-2.355 5.712-5.16 0-2.706-2.105-5.01-5.712-5.01H7.866v10.17h6.229zM218 6.397c0 2.841-2.196 4.897-4.876 4.897-2.64 0-4.836-2.035-4.836-4.856 0-2.821 2.196-4.856 4.876-4.856 2.64 0 4.836 2.015 4.836 4.815zm-.886.02c0-2.317-1.815-3.989-3.95-3.989-2.156 0-3.99 1.672-3.99 4.01 0 2.317 1.814 3.989 3.95 3.989 2.156 0 3.99-1.672 3.99-4.01zm-5.038 2.459h-.907V3.799h2.58c.966 0 1.652.583 1.652 1.39 0 .684-.463 1.228-1.149 1.41l1.351 2.277h-1.069l-1.128-2.196h-1.33v2.196zm1.673-4.292h-1.673v1.309h1.592c.503 0 .866-.281.866-.685 0-.362-.322-.624-.785-.624z"
                        />
                    </svg>
                </ProLink>
                <div class="pro-nav__main-content">
                    <ProNavDropdownBackground />
                    <ul>
                        <li>
                            <ProNavDropdown
                                :label="$t('navigation.explore')"
                                :lists="[$t('navigation.menu_explore'), $t('navigation.menu_activities')]"
                                :order="1"
                            />
                        </li>
                        <li>
                            <ProNavDropdown
                                :label="$t('navigation.products')"
                                :lists="[$t('navigation.menu_procreate'), $t('navigation.menu_pocket')]"
                                :order="2"
                            />
                        </li>
                        <li>
                            <ProLink :to="{ name: 'support' }" class="pro-nav__link">{{ $t("navigation.support") }}</ProLink>
                        </li>
                        <li>
                            <ProLink
                                v-fathom-event:click="['TYVOSEIS']"
                                href="https://apps.apple.com/app/apple-store/id425073498"
                                class="pro-nav__link pro-nav__link--primary"
                                target="_blank"
                                >{{ $t("global.buy_now") }}</ProLink
                            >
                        </li>
                    </ul>
                    <button
                        @click="toggleMenu"
                        class="pro-nav__menu-button"
                        :title="$t('navigation.menu_alt')"
                        :aria-label="$t('a11y-labels.header.mobile_button')"
                    >
                        <span></span>
                    </button>
                </div>
            </div>

            <transition name="pro-nav--mobile-transition">
                <ul class="pro-nav__mobile container" v-show="mobileMenuActive">
                    <li class="pro-nav__mobile-section">
                        <ProNavMobileSection :label="$t('navigation.menu_procreate.label_mobile')" :list="$t('navigation.menu_procreate.items')" />
                    </li>
                    <li class="pro-nav__mobile-section">
                        <ProNavMobileSection :label="$t('navigation.menu_pocket.label')" :list="$t('navigation.menu_pocket.items')" />
                    </li>
                    <li class="pro-nav__mobile-section">
                        <ProNavMobileSection :label="$t('navigation.menu_explore.label')" :list="$t('navigation.menu_explore.items')" />
                    </li>
                    <li class="pro-nav__mobile-section">
                        <ProNavMobileSection :label="$t('navigation.menu_activities.label')" :list="$t('navigation.menu_activities.items')" />
                    </li>
                    <li class="pro-nav__mobile-section">
                        <ProLink class="pro-nav__mobile-section-button" :to="{ name: 'support' }">{{ $t("navigation.support") }}</ProLink>
                    </li>
                    <li class="pro-nav__mobile-section">
                        <ProLink
                            v-fathom-event:click="['TYVOSEIS']"
                            class="pro-nav__mobile-section-button pro-nav__mobile-section-button--primary"
                            href="https://apps.apple.com/app/apple-store/id425073498"
                            target="_blank"
                            >{{ $t("global.buy_now") }}</ProLink
                        >
                    </li>
                </ul>
            </transition>
        </div>
    </nav>
</template>

<script>
import ProNavDropdown from "@/components/ProNavDropdown";
import ProNavMobileSection from "@/components/ProNavMobileSection";
import ProNavDropdownBackground from "@/components/ProNavDropdownBackground";
import { mapGetters } from "vuex";

export default {
    components: {
        ProNavDropdown,
        ProNavMobileSection,
        ProNavDropdownBackground,
    },

    data: () => ({
        mobileMenuActive: false,
        mediaQueryList: null,
    }),

    computed: {
        maxMobileNavWidth() {
            return window.getComputedStyle(document.documentElement).getPropertyValue("--mobile-nav-breakpoint");
        },
    },

    methods: {
        toggleMenu() {
            this.mobileMenuActive = !this.mobileMenuActive;
            this.$nextTick(() => (document.body.style.overflow = this.mobileMenuActive ? "hidden" : null));
        },

        checkMobileMenuVisibility(e) {
            if (e.type !== "resize") {
                if (e.matches && this.mobileMenuActive) {
                    this.$emit("mobile-menu-active-changed", true);
                } else {
                    this.mobileMenuActive = false;
                    this.$nextTick(() => (document.body.style.overflow = this.mobileMenuActive ? "hidden" : null));
                    this.$emit("mobile-menu-active-changed", false);
                }
            } //for everyone except old Safari
            else {
                let isMobileSize = window.innerWidth <= parseInt(this.maxMobileNavWidth, 10);
                if (isMobileSize && this.mobileMenuActive) {
                    this.$emit("mobile-menu-active-changed", true);
                } else {
                    this.$emit("mobile-menu-active-changed", false);
                }
            } //for old safari
        },

        handleFocusInEvent(e) {
            if (this.mobileMenuActive && this.mediaQueryList.matches && !this.$el.contains(e.target)) {
                this.autoFocus();
            }
        },
    },

    watch: {
        $route() {
            this.mobileMenuActive = false;
            this.$nextTick(() => (document.body.style.overflow = this.mobileMenuActive ? "hidden" : null));
        },
    },

    mounted() {
        this.mediaQueryList = window.matchMedia(`(max-width: ${this.maxMobileNavWidth})`);

        try {
            this.mediaQueryList.addEventListener("change", this.checkMobileMenuVisibility);
        } catch {
            this.mediaQueryList.addListener(this.checkMobileMenuVisibility);
        }
    },

    beforeDestroy() {
        try {
            this.mediaQueryList.removeEventListener("change", this.checkMobileMenuVisibility);
        } catch {
            this.mediaQueryList.removeListener(this.checkMobileMenuVisibility);
        }
    },
};
</script>
